import React from 'react';
import { R } from '@leverege/value-resolver';
import { alertLabels, alertVariants } from "../../attributes/EquipmentCalculatedAlerts.js";
import AlertPopup from "../../../../attributes/renderers/vehicle/AlertPopup.js";
export default {
  install(molten) {
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'assetLocators',
      attrName: 'assetLocators.calculatedAlerts',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(AlertPopup, {
            value: data.value,
            alertLabels: R(alertLabels),
            alertVariants,
            defaultFirstPillVariant: 'pillError',
            defaultLastPillVariant: 'pillError',
            table: true
          });
        }
        return null;
      }
    });
  }
};